import React from "react";

function ViewExpenseModal({ isOpen, setModal, onClose, expenseData }) {
  if (!isOpen) return null;
  return (
    <>
      {isOpen && (
        <div className="fixed w-full h-full top-0 left-0 flex items-center justify-center z-50 overflow-auto">
          <div className="absolute w-full h-full bg-gray-900 opacity-50"></div>
          <div className="relative bg-white rounded-lg w-11/12 max-w-lg mx-auto my-6">
            {/* Close Button */}
            <button
              className="absolute top-0 right-0 m-4 text-gray-500 hover:text-gray-800"
              onClick={() => {
                setModal(false);
              }}
            >
              <svg
                className="h-6 w-6 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  fillRule="evenodd"
                  d="M18.293 5.293a1 1 0 0 1 1.414 1.414L13.414 12l6.293 6.293a1 1 0 1 1-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 1 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 1 1 1.414-1.414L12 10.586l6.293-6.293z"
                />
              </svg>
            </button>
            {/* Content */}
            <div className="p-5">
              <h2 className="text-xl font-semibold mb-2">Expense Details</h2>
              <p><strong>Description:</strong> {expenseData.description}</p>
              <p><strong>Total Amount:</strong> ₹{expenseData.totalAmount}</p>
              <p><strong>Paid By:</strong> {expenseData.paidBy}</p>
              <p><strong>Date:</strong> {new Date(expenseData.date).toLocaleDateString()}</p>
              <p><strong>Participants:</strong></p>
              <ul>
                {expenseData.participants.map((participant, index) => (
                  <li key={index}>
                    <strong>User:</strong> {participant.userId}, <strong>Share:</strong> ₹{participant.share}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ViewExpenseModal;
